'use client';

import { createClient } from '@/lib/supabase/client';
import { useSearchParams } from 'next/navigation';
import { FcGoogle } from 'react-icons/fc';
import BottomGradient from '../ui/bottom-gradient';

export default function GoogleLogin() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl') || '/';

  const handleGoogleLogin = async () => {
    const supabase = await createClient();
    try {
      // Get the current origin (works for both localhost and production)
      const siteUrl = typeof window !== 'undefined' ? window.location.origin : '';

      // Build the redirect URL with the callback URL as a query parameter
      const redirectTo = new URL('/auth/callback', siteUrl);
      redirectTo.searchParams.set('next', callbackUrl);

      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: redirectTo.toString(),
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          },
        },
      });
      if (error) {
        throw error;
      }
    } catch (error: unknown) {
      console.error('Google Login Error:', error);
    }
  };

  return (
    <div className='flex flex-col space-y-4'>
      <button
        aria-label='Sign in with Google'
        className='group/btn shadow-input relative flex h-10 w-full cursor-pointer items-center justify-center space-x-2 rounded-md bg-gray-50 px-4 font-medium text-black dark:bg-zinc-900'
        type='button'
        onClick={handleGoogleLogin}
      >
        <FcGoogle className='h-4 w-4 text-neutral-800 dark:text-neutral-300' aria-hidden='true' />
        <span className='text-sm text-neutral-700 dark:text-neutral-300'>Continue with Google</span>
        <BottomGradient />
      </button>
    </div>
  );
}
